import React from 'react';
import { Route } from "react-router-dom";
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';

const AzureRoute = ({ component: Component, path, redirectPath = "backoffice" }) => {
    const authenticationRequest = {
        redirectUri: window.location.origin + window.settings.SiteRoot + redirectPath
    };

    return (<Route path={path} render={(props) => (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authenticationRequest}>
            <Component {...props} />
        </MsalAuthenticationTemplate>
    )} />);
};

export default AzureRoute;
